import { render, staticRenderFns } from "./AdSpendBreakdown.vue?vue&type=template&id=da33497a&scoped=true&"
import script from "./AdSpendBreakdown.vue?vue&type=script&lang=js&"
export * from "./AdSpendBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da33497a",
  null
  
)

export default component.exports